import React from "react";
import ModalBody from "reactstrap/lib/ModalBody";
import Modal from "reactstrap/lib/Modal";
import CloseIcon from "@material-ui/icons/Close";
import DragAndDropUpload from "../../../components/DragAndDropUpload";
import ReconciliationService from "../../../Services/ReconciliationService";
import { chunkArray, handleError } from "../../../components/Utils/Utils";
import InvoiceService from "../../../Services/InvoiceService";
import { CircularProgress } from "@material-ui/core";
import History from "../../../History/History";

const ModalUpload = (props) => {
  const { modal, toggle, onReconciliationDone } = props;
  const [status, setStatus] = React.useState("");
  const [error, setError] = React.useState(false);
  const radioTypeRef = React.useRef();

  const bulkupdateInvoice = (params) => {
    return new Promise((resolve, reject) => {
      InvoiceService.bulkupdateInvoice({
        invoices_settled: params
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  const loopReconciliationData = async (data, id) => {
    const chunkedArr = chunkArray(data, 10);
    for (const val of chunkedArr) {
      await bulkupdateInvoice(val);
    }
    onReconciliationDone(id);
  }

  const storeReconciliationTransaction = (params, id) => {
    setStatus("Save data from Xendit ...");
    ReconciliationService.storeReconciliationTransaction(params)
      .then((response) => {
        setStatus("Saved data from Xendit");
        setError(false);
        loopReconciliationData(response.data, id);
      })
      .catch((error) => {
        setStatus("Failed save data from Xendit");
        setError(true);
        handleError(error);
      });
  };

  const getInvoiceReconciliation = (id) => {
    setStatus("Read data from Xendit ...");
    InvoiceService.getInvoiceReconciliation(id)
      .then((response) => {
        setStatus("Read data from Xendit Done !");
        setError(false);
        const data = response.data;
        storeReconciliationTransaction(data, id);
      })
      .catch((error) => {
        setStatus("Error read data from Xendit");
        setError(true);
        handleError(error);
      });
  };

  const onUploadDone = (response) => {
    const data = response.data;
    ReconciliationService.storeReconciliation({ file_url: data.url })
      .then((response) => {
        setStatus("Save CSV File");
        setError(false);
        const data = response.data;
        getInvoiceReconciliation(data.result.id);
      })
      .catch((error) => {
        setStatus("Failed save CSV File");
        setError(true);
        handleError(error);
      });
  };

  React.useEffect(() => {
    if (modal === false) {
      setError(false);
      setStatus("");
    }
  }, [modal]);

  return (
    <Modal isOpen={modal} toggle={toggle} centered={true}>
      <ModalBody>
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-left">
            <p className="font-12 font-bold text-primary mb-0">Jenis File</p>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="type"
                ref={radioTypeRef}
                value="xendit"
                defaultChecked
              />
              <label
                className="form-check-label font-10 text-primary"
                htmlFor={radioTypeRef}
              >
                Xendit
              </label>
            </div>
          </div>
          <button type="button" className="btn" onClick={toggle}>
            <CloseIcon />
          </button>
        </div>
        {status === "" && (
          <DragAndDropUpload
            target="csv"
            accept="text/csv, application/vnd.ms-excel"
            onUploadDone={(response) => onUploadDone(response)}
          />
        )}

        {status !== "" && (
          <div className="w-100 w-100 d-flex flex-column justify-content-center align-items-center p-5">
            <span
              className={
                error
                  ? "font-12 text-error font-bold text-center"
                  : "font-12 text-primary font-bold text-center"
              }
            >
              {!error && (
                <React.Fragment>
                  <CircularProgress size="1rem" />
                  <span className="ml-2">{status}</span>
                </React.Fragment>
              )}

              {error && status}
            </span>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalUpload;
